import * as React from 'react';

function LocalIconInterfaceEssentialBack(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4 17.176l-1.647 1.654-7.44-7.409 7.408-7.44 1.654 1.646-4.406 4.425 12.023-.026a4.667 4.667 0 014.677 4.656l.02 9.334-2.334.005-.02-9.334a2.333 2.333 0 00-2.338-2.328l-12.408.027 4.81 4.79z"
        fill="currentColor"
      />
    </svg>
  );
}

export const IconInterfaceEssentialBack = React.memo(LocalIconInterfaceEssentialBack);
